/**
 * Bounded time-series recorder (009). Samples snapshots on an interval into a
 * ring capped by count, so memory stays bounded over a long call (SC-005).
 */
import { snapshot, type DiagnosticSnapshot } from './collector.js'

const MAX_SAMPLES = 600 // ~20 min at 2s cadence
const DEFAULT_INTERVAL_MS = 2000

let samples: DiagnosticSnapshot[] = []
let timer: ReturnType<typeof setInterval> | null = null

/** Push `item` into `arr`, dropping oldest entries so length never exceeds `max`. */
export function pushBounded<T>(arr: T[], item: T, max: number): void {
  arr.push(item)
  if (arr.length > max) arr.splice(0, arr.length - max)
}

export function isRecording(): boolean {
  return timer !== null
}

export function startRecording(intervalMs: number = DEFAULT_INTERVAL_MS): void {
  if (timer !== null) return
  samples = []
  timer = setInterval(() => {
    void appendSample()
  }, intervalMs)
}

async function appendSample(): Promise<void> {
  pushBounded(samples, await snapshot(), MAX_SAMPLES)
}

export function stopRecording(): void {
  if (timer !== null) {
    clearInterval(timer)
    timer = null
  }
}

/** Time-ordered copy of the recorded samples. */
export function exportTimeline(): DiagnosticSnapshot[] {
  return samples.slice()
}
